import { Context, StudyPlanTargets, Transitions } from "../../types"
import { setSPV2RedirectUrl } from "./setSPV2RedirectUrl"

export const selectSubjectAction = (
  ctx: Context,
  event: Transitions
): Partial<Context> => {
  if (event.type !== "SELECT_SUBJECT" || event.newSubject === ctx.subject) {
    return {}
  }

  if (!event.newSubject) {
    return {
      subject: null,
      ...setSPV2RedirectUrl(
        ctx,
        event,
        { action: { action: "replace" } },
        StudyPlanTargets.Progress
      )
    }
  }

  if (!ctx.subject && !!event.newSubject) {
    return {
      subject: event.newSubject,
      ...setSPV2RedirectUrl(
        ctx,
        event,
        { action: { action: "replace" } },
        StudyPlanTargets.ProgressByContent
      )
    }
  }

  return {
    subject: event.newSubject
  }
}
